import AttachFileIcon from '@mui/icons-material/AttachFile';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import PersonIcon from '@mui/icons-material/Person';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import SendIcon from '@mui/icons-material/Send';
import axios from "axios";
import _ from 'lodash';
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from "reactstrap";
import emptyChatImg from '../../../../assets/img/still_rocket.png';
import { boxiPrimary, boxiRed } from "../../../../assets/style/colors";
import MediaUpload from "../MediaUpload/MediaUpload";
import Message from "../Message/Message";
import PictureBlastModal from "../PictureBlastModal/PictureBlastModal";
import ScheduleSend from "../ScheduleSend/ScheduleSend";
import Templates from "../Templates/Templates";
import classes from './MessageBox.module.scss';
import Button from "../../../general/Button/Button";
import { Link, NavLink } from "react-router-dom";



const MessageBox = ({ shouldScrollDown, setShouldScrollDown, threadPaginationStatus, setThreadPaginationStatus, threadMessagesCount, threadListingOffset, setThreadListingOffset, pictureBlastVendorList, vendorId, messages, className, selectedVendor, isLoading, vendorName, isCurrentChatBlocked, isCurrentChatPictureBlast, asAWidget = false, vendorPhoneNumber = null}) => {
  const [messageInputValue, setMessageInputValue] = useState('');
  const messageEl = useRef(null);
  const textAreaRef = useRef(null);
  const [isMessageSending, setMessageSending] = useState(false);
  const [isModalOpen, openModal] = useState(false);
  const [uploadedImageURL, setUploadedImageURL] = useState([]);
  const [imagePath, setImagePath] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [templateForMessage, setTemplateForMessage] = useState(null);
  const [pictureBlastModal, setPictureBlastModal] = useState(false)
  const [showListIcon, setShowListIcon] = useState(false)

  const buttonStyle = {
    fontSize: "14px",
    padding: "5px 7px",
    width: "100%",
    boxSizing: "border-box"
  };

  // send sms
  const messageSentHandler = async (e) => {
    if (e) e.preventDefault();

    if(messageInputValue?.trim().length > 0 || uploadedImageURL?.length > 0) {
      try {
        setMessageSending(true);
        const body = { 
          to: selectedVendor.phone_number, 
          body: messageInputValue && messageInputValue.trim().length > 0 ? messageInputValue.trim() : '', 
          sender_id: JSON.parse(localStorage.getItem("userId")) 
        }

        if (uploadedImageURL.length > 0) body['media'] = uploadedImageURL;
        if (schedule) body['schedule'] = schedule.toISOString();

        const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send`, body)
        // await getNewMessages(selectedVendor.vendor_id, selectedVendor.phone_number);
        setMessageInputValue('');
        setMessageSending(false);
        setUploadedImageURL([]);
        setTemplateForMessage(null);
        setImagePath(null);
        setSchedule(null);
              } catch (error) {
        console.error(error);
        setMessageSending(false);
      }
    }
  }

  useEffect(() => {
    if(pictureBlastVendorList.length > 0){
      let isPresent = pictureBlastVendorList.find(vendor => vendor.vendor_id == vendorId)
      if(isPresent?.vendor_id){
        setShowListIcon(true)
      }
    }

    return () => {
      setShowListIcon(false)
    }

  }, [pictureBlastVendorList, vendorId])

  useEffect(() => {
    const targetElement = messageEl.current;
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          messageEl.current.lastElementChild.scrollIntoView({ block: 'end' })
        }
      }
    });

    if (targetElement) {
      observer.observe(targetElement, { childList: true });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (shouldScrollDown) { 
      const target = messageEl?.current?.lastElementChild;
      if (target !== null && target !== undefined) {
        const _target = target.lastElementChild;
        if (_target !== null && !_target !== undefined) {
          console.log(_target);
          _target.firstElementChild.scrollIntoView({ block: 'end' });
        }
      }
      setShouldScrollDown(false); 
    }
  }, [shouldScrollDown])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      messageSentHandler();
    }
  };

  const generateAvatarBackgroundColor = (name) => {
    let numericValue = 0;
    for (let i = 0; i < name.length; i++) {
      numericValue += name.charCodeAt(i);
    }
    const hue = numericValue % 360; // Use modulo to restrict the hue to a range of 0-359
    const saturation = 70; // Set a fixed saturation value
    const lightness = 50; // Set a fixed lightness value
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    return color;
  };

  const shortenString = (str) => {
    if (str.length > 18) {
        return str.substring(0, 18) + "...";
    } else {
        return str;
    }
}

  useEffect(() => {
    setMessageInputValue(templateForMessage?.template_body);
  }, [templateForMessage])

  const formatPhoneNumberToE164 = (phoneNumber) => {
    if (phoneNumber !== '') {
      const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
      return numericPhoneNumber.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
    }
  }

  const removeImage = (index) => {
    let tempUploadedImageURL = _.cloneDeep(uploadedImageURL)
    let tempImagePath = _.cloneDeep(imagePath)

    tempUploadedImageURL = tempUploadedImageURL.filter((val, i) => i !== index)
    tempImagePath = tempImagePath.filter((val, i) => i !== index)

    setUploadedImageURL(tempUploadedImageURL)
    setImagePath(tempImagePath)
  }

  return (
    <>
      {messages.length === 0 && 
        <div className={classes.emptyImg}>
          <img className={`${isLoading ? classes.bluredImg : ''}`} style={{ height: '65vh' }} src={emptyChatImg} alt="Empty Chat" />
          {isLoading && 
            <div className={classes.loadingState}>
              <Spinner style={{color: boxiPrimary}}></Spinner>
              <div>Loading Messages...</div>
            </div>
          }
        </div>
      }
      {messages.length !== 0 && <div className={`d-flex bg-white p-2 ${classes.stickyVendorHeader} ${asAWidget && 'mt-2'}`}>
          <div className="d-flex align-items-center" style={{ flex: '1' }}>
            {vendorName && <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(vendorName) }}>{vendorName[0] === '+' ? <PersonIcon /> : vendorName.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}</div>}
            <div className={`overflow-hidden`} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              {vendorName && <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{asAWidget ? shortenString(vendorName): vendorName}</div>}
              {vendorName[0] !== '+' && <div className="overflow-hidden text-truncate" style={{fontSize: '12px'}}>{formatPhoneNumberToE164(selectedVendor?.phone_number)}</div>}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div className={classes.navigationButton}>
              {/* Button added for transition between vendor detail page and communication tab */}
              {vendorId != -1 &&<a 
                  href={asAWidget ? `/dashboard/admin/communication/${vendorName}/${vendorPhoneNumber}/${vendorId}` : `/dashboard/admin/drive/vendor/edit/${vendorId}`} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ 
                    textDecoration: 'none',
                    color: 'white', // Set text color to white
                    backgroundColor: '#B93A76', // Set background color to red
                    borderRadius: '15px', // Set border radius to make background rounded
                    padding: '5px 10px', // Add some padding for better visual appearance
                    display: 'inline-block' // This makes the padding and borderRadius effective
                  }}
                >
                  {asAWidget ? "Go to Thread" : "Vendor Details"}
                </a>}
            </div>
          </div>
          {showListIcon && 
          (
            <div style={{ alignSelf: 'center', marginRight: '150px', fontSize: 12, display: 'flex', flexWrap: 'wrap', gap: '15px'}}>
              <div onClick={()=>setPictureBlastModal(true)}><ListOutlinedIcon fontSize="small" style={{ color: boxiPrimary, cursor: 'pointer' }} /> Trucks on Campaign</div> 
            </div>
          )
          }
          {isCurrentChatBlocked && <div style={{ alignSelf: 'center', marginLeft: 'auto', fontSize: 12, color: boxiRed }}><BlockIcon fontSize="small" style={{ color: boxiRed }} /> Potentially Blocked</div>}
        </div>}
      <div className={`${ asAWidget ? 'pr-0':'pr-3'} overflow-auto text-center ${messages ? '' : 'd-none'} ${className}`} ref={messageEl} 
        style={{ maxHeight: 'calc(100dvh - 300px)', minHeight: 'calc(100dvh - 300px)' }}
      >
        <InfiniteScroll
          dataLength={messages?.length}
          hasMore={threadMessagesCount !== messages?.length}
          next={() => { if (threadPaginationStatus === 0) setThreadListingOffset((prev) => prev + 1); }}
          height={window.innerHeight - 300}
          inverse={true}
          style={{ display: 'flex', flexDirection: 'column-reverse', backgroundColor: '#e4e4e4' }}
          loader={threadMessagesCount !== messages?.length && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
        >  
          {messages && messages.length > 0 && messages.map((item) => <Message key={item.id} message={item} isCurrentChatPictureBlast={showListIcon}  vendor_id={vendorId}/>)}
        </InfiniteScroll>
        {/* {messages && messages.map((item) => <Message ref={messageEl} key={item.id} message={item} isCurrentChatPictureBlast={showListIcon}  vendor_id={vendorId}/>)} */}
      </div>
      <form style={{ position: 'sticky', bottom: 0 }} onSubmit={(e) => messageSentHandler(e)} ref={textAreaRef}>
        {messages.length > 0 && 
          <>
            <div className={`d-flex ${messages.length > 0 ? '' : 'd-none'} ${classes.textAreaContainer}`}>
              <textarea 
                type="text" 
                className={`form-control ${classes.textArea}`} 
                placeholder="Text message..." 
                aria-label="Text message" 
                aria-describedby="send-button" 
                onChange={(e) => setMessageInputValue(e.target.value)} 
                onKeyDown={handleKeyDown}
                value={messageInputValue} 
                rows={3} 
                disabled={isCurrentChatBlocked}
                style={{resize: 'none'}}
              ></textarea>
              {schedule ? 
                <div className={classes.sendButton}>
                 <button disabled={isMessageSending || isCurrentChatBlocked} class={`${classes.sendButton}`} id="send-button" type="submit">
                    {isMessageSending ? <Spinner style={{ color: boxiPrimary, cursor: 'not-allowed', height: 20, width: 20}} /> : <ScheduleSendIcon style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />}
                  </button>
                </div> 
                :
                <>
                <div className={classes.sendButton}>
                  <button disabled={isMessageSending || isCurrentChatBlocked} class={`${classes.sendButton}`} id="send-button" type="submit">
                    {isMessageSending ? <Spinner style={{ color: boxiPrimary, cursor: 'not-allowed', height: 20, width: 20}} /> : <SendIcon style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />}
                  </button>
                </div>
                {!isMessageSending && <div className={ asAWidget ? classes.attachButton : classes.scheduleButton}>
                  {/* as a Widget Means that this communication tab is used as a child component in other component */}
                    { asAWidget && <AttachFileIcon onClick={() => openModal(true)} style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />}
                    {!asAWidget && <button type="button" class={`${classes.sendButton}`} onClick={() => setIsScheduleModalOpen(true)} disabled={isCurrentChatBlocked}>
                        {isMessageSending ? <Spinner style={{ color: boxiPrimary, cursor: 'not-allowed', height: 20, width: 20}} /> : <ScheduleIcon style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />}
                      </button>}
                </div>}
              </>}
              {schedule && <div className={classes.schedule}>
                <div>Message is scheduled to be sent on {schedule.format('MMMM Do')} at {schedule.format('hh:mm A')}</div>
              </div>}
            </div>
            { !asAWidget && <div className="d-flex py-2 border border-top-1 border-left-0 border-right-0 border-bottom-0 align-items-center" style={{ columnGap: 12, height: 60, overflow: 'auto', backgroundColor: `${!isCurrentChatBlocked ? '#fff' : '#e9ecef'}` }}>
              <div style={{ display: 'flex', alignItems: 'center', columnGap: 12, backgroundColor: `${!isCurrentChatBlocked ? '#fff' : '#e9ecef'}`, position: 'sticky', left: 0, height: 55 }}>
                <AttachFileIcon onClick={() => openModal(true)} style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />
                <DescriptionIcon onClick={() => setIsTemplateModalOpen(true)} style={{ color: `${!isCurrentChatBlocked ? boxiPrimary : '#A2A2A2'}`, cursor: `${!isCurrentChatBlocked ? 'pointer' : 'not-allowed'}` }} />
              </div>
              {templateForMessage && <div className={classes.schedule}>
                <div>Template in use: {templateForMessage?.template_name}</div>
              </div>}
              {imagePath && imagePath.length > 0 && imagePath.map((image, index) => (
                <div className={classes.imagePath}>
                  {image.file_name}
                  <CloseIcon style={{ color: boxiPrimary, cursor: 'pointer' }} onClick={() => removeImage(index)} />
                </div>
              ))
              }
            </div>}
            {/* div to show Attach file that is Selected */}
            {asAWidget && imagePath && imagePath.length > 0 && <div className="d-flex pt-2 px-2 border border-top-1 border-left-0 border-right-0 border-bottom-0 align-items-center ">
            { asAWidget && imagePath && imagePath.length > 0 && imagePath.map((image, index) => (
                <div className={classes.imagePath}>
                  {image.file_name}
                  <CloseIcon style={{ color: boxiPrimary, cursor: 'pointer' }} onClick={() => removeImage(index)} />
                </div>
              ))
              }
              </div>}
          </>
        }
      </form>
      {pictureBlastModal && (<PictureBlastModal openModal={setPictureBlastModal} isModalOpen={pictureBlastModal} vendorId={vendorId}/>)}
      {isModalOpen && <MediaUpload openModal={openModal} isModalOpen={isModalOpen} setUploadedImageURL={setUploadedImageURL} setImagePath={setImagePath} />}
      {isScheduleModalOpen && <ScheduleSend openModal={setIsScheduleModalOpen} isModalOpen={isScheduleModalOpen} setMessageSchedule={setSchedule} />}
      {isTemplateModalOpen && <Templates openModal={setIsTemplateModalOpen} isModalOpen={isTemplateModalOpen} type='selection' setTemplateForMessage={setTemplateForMessage} />}
    </>
  );
}
export default MessageBox;
